import Query from "components/common/gql-query"
import { FETCH_DIRECTOR_PRODUCTS } from "lib/graphql/queries"
//import { useProducts } from "lib/products"
import Products from "components/common/products"

export default ({directorId, renderLoading, children}) => {

	//const { products } = useProducts()

	return (
		<Query
			query={FETCH_DIRECTOR_PRODUCTS}
			options={{variables: { id: directorId }}}
			renderLoading={renderLoading}
		>
			{({cms: { directors: { items: [{products: { items }}] }}}) => (
				<Products products={items.map(i => i.product)}>
					{ products => {
							let films = products
								.filter(p => p.available && p.directorsIds.includes(directorId))
							films = films.sort((a, b) => {
								return a.year > b.year ? 1 : -1
							})
							return children(films)
					}}
				</Products>
			)}
		</Query>
	)
}
